
export type GetProfileByUsername500 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
